import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-117" data-mp="20m4qnvskykwl">
      <div className="mx-auto w-full max-w-2xl rounded-3xl border border-gold-500/40 bg-white p-6 text-center shadow-card sm:p-10" data-id="element-118" data-mp="24mye6o241xoy">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-100" data-id="element-119" data-mp="29fhptfh8mir4">
          <ShieldCheckIcon className="h-8 w-8 text-gold-500" aria-hidden="true" data-id="element-120" data-mp="2ecrprp296ct7" />
        </span>
        <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-gold-500" data-id="element-121" data-mp="2jajgwgv2puwc">
          🛡️ 7-Day Complete Guarantee
        </p>
        <h2 className="mt-3 font-display text-[26px] font-bold leading-snug text-navy-950 sm:text-3xl" data-id="element-122" data-mp="2sciz3chtr50v">
          Explore the System Completely Risk-Free
        </h2>
        <div className="mt-4 space-y-3 text-[14.5px] leading-relaxed text-slate-600" data-id="element-123" data-mp="tyzj86xkqr38">
          <p data-id="element-124" data-mp="xz9v2081sbq0">
            Take the first 7 days to go through the material, explore the protocols and see how the
            system fits into your clinical workflow.
          </p>
          <p data-id="element-125" data-mp="3ntoqnrhly9it">
            If during those first 7 days you feel the system doesn’t help you structure your
            diagnostic process, simply contact us.
          </p>
          <p className="font-bold text-navy-950" data-id="element-126" data-mp="3dx28xbkkvyl0">
            We’ll refund 100% of your purchase. No complicated process. No long explanations. No
            questions asked.
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-127" data-mp="afadtob5ayil">
          <CTAButton label="Try it risk-free for 7 days" data-id="element-128" data-mp="aglbr7hwtc1s" />
        </div>
      </div>
    </section>;
}